export const eventWorkspaceRoute = (eventId: number | string, section = "overview") =>
    `/Admin/Events/${eventId}/${section}`;

export const eventScopedAdminRoute = (route: string, eventId: number | string) =>
    `${route}?eventId=${eventId}`;

export const eventParticipantRoute = (
    eventId: number | string,
    participantId: number | string
) => `/Admin/Events/${eventId}/participants/${participantId}`;
